import { useEffect, useRef } from 'react';

// Requests a screen wake lock while mounted. Re-acquires on visibility changes.
export function useWakeLock(enabled: boolean = true) {
  const wakeLockRef = useRef<any>(null);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    const requestWakeLock = async () => {
      try {
        // @ts-ignore: navigator.wakeLock is experimental
        if ('wakeLock' in navigator && (navigator as any).wakeLock?.request) {
          // @ts-ignore
          const lock = await (navigator as any).wakeLock.request('screen');
          if (!cancelled) {
            wakeLockRef.current = lock;
            console.log('[WakeLock] Screen wake lock acquired');
            lock.addEventListener?.('release', () => {
              console.log('[WakeLock] Screen wake lock released. Document hidden:', document.hidden);
              wakeLockRef.current = null;
              // Attempt to re-acquire on unexpected release
              if (!document.hidden) {
                console.log('[WakeLock] Attempting to re-acquire wake lock...');
                requestWakeLock();
              }
            });
          }
        } else {
          console.warn('[WakeLock] Wake Lock API not supported in this browser');
        }
      } catch (err) {
        console.error('[WakeLock] Failed to acquire wake lock:', err);
      }
    };

    const handleVisibilityChange = () => {
      console.log('[WakeLock] Visibility changed. State:', document.visibilityState, 'Has lock:', !!wakeLockRef.current);
      if (document.visibilityState === 'visible' && !wakeLockRef.current) {
        console.log('[WakeLock] Page visible, re-acquiring wake lock...');
        requestWakeLock();
      }
    };

    requestWakeLock();
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      cancelled = true;
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      try {
        wakeLockRef.current?.release?.();
      } catch (_) {
        // noop
      }
      wakeLockRef.current = null;
    };
  }, [enabled]);
}

export default useWakeLock;


